import { render } from "./AppForm.vue?vue&type=template&id=40dbe38f&scoped=true"
import script from "./AppForm.vue?vue&type=script&lang=js"
export * from "./AppForm.vue?vue&type=script&lang=js"

import "./AppForm.vue?vue&type=style&index=0&id=40dbe38f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dbe38f"]])

export default __exports__